import api from '../../lib/api';

export const addPlan = data =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/action/plan', data, (error, response) => {
        if (error) return console.error(error);
        dispatch(addPlanSuccess(response.data));
        return dispatch(getPlans());
      });
  };

export const deletePlan = planId =>
  function get(dispatch) {
    api
      .sendDelete(`/public-dashboard/action/plan/${planId}`, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getPlans());
      });
  };

export const updatePlan = data =>
  function get(dispatch) {
    api
      .sendPut(`/public-dashboard/action/plan/${data.id}`, data, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getPlans());
      });
  };

export const getPlans = () =>
  function get(dispatch) {
    api
      .sendGet('/public-dashboard/action/plan', (error, response) => {
        if (error) return console.error(error);
        return dispatch(getPlansSuccess(response.data.data));
      });
  };

export const getPlansSuccess = data => ({
  type: 'GET_PLANS_SUCCESS',
  data,
});

export const addPlanSuccess = data => ({
  type: 'CREATE_PLAN_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/plan.js